import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgStore2 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 5H2a1 1 0 0 0-1 1v4a1 1 0 0 0 .486.857l.699.42.216.122a4.5 4.5 0 0 0 4.414-.122L7 11.166l.185.111.216.122a4.5 4.5 0 0 0 4.414-.122l.185-.111.185.111.216.122a4.5 4.5 0 0 0 4.414-.122l.185-.111.185.111a4.5 4.5 0 0 0 4.63 0l.7-.42A1 1 0 0 0 23 10V6a1 1 0 0 0-1-1Zm-1 2v2.433l-.214.13a2.5 2.5 0 0 1-2.572 0l-.7-.42a1 1 0 0 0-1.028 0l-.7.42a2.5 2.5 0 0 1-2.572 0l-.7-.42a1 1 0 0 0-1.028 0l-.7.42a2.5 2.5 0 0 1-2.572 0l-.7-.42a1 1 0 0 0-1.028 0l-.7.42-.16.088a2.5 2.5 0 0 1-2.412-.089L3 9.434V7h18Z" />
      <path d="M20 10a1 1 0 0 1 .993.883L21 11v11a1 1 0 0 1-.883.993L20 23H4a1 1 0 0 1-.993-.883L3 22V11.244a1 1 0 0 1 1.993-.116l.007.116V21h14V11a1 1 0 0 1 .883-.993L20 10ZM20 1a1 1 0 0 1 .993.883L21 2v4a1 1 0 0 1-1.993.117L19 6V3H5v2.911a1 1 0 0 1-.883.993L4 6.911a1 1 0 0 1-.993-.883L3 5.91V2a1 1 0 0 1 .883-.993L4 1h16Z" />
      <path d="M14.5 15h-5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-1 2v4h-3v-4h3Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgStore2)
const Memo = memo(ForwardRef)
export default Memo
